import { v5 as uuidV5 } from 'uuid';

export const convertStringToFixedUuid = (str: string): string => {
  // Reference: https://github.com/uuidjs/uuid?tab=readme-ov-file#uuidv5name-namespace-buffer-offset
  const customNamespace =
    'c0aef3e6-5ece-4049-992a-2645188c801c' satisfies string; // Generate a custom namespace
  return uuidV5(str, customNamespace);
};
